const FINES = [
    'eor_fine',
    'tg_fine',
    'hb_fine',
    'nc_fine',
    'MsgEyesOffRoad_fine',
    'MsgTailgatingDetection_fine',
    'MsgHardbrake_fine',
    'MsgNearCollision_fine',
    'MsgCollisionTrackDetection_fine',
    'MsgRecurringEOR_fine',
    'MsgRecurringTG_fine',
    'MsgSleep_fine',
    'MsgSpeedingDetection_fine',
    'claim_fine',
    'compliance_fine',
];
const EVENT_COUNTS = [
    'tg_all_events_count',
    'eor_all_events_count',
    'hb_all_events_count',
    'nc_all_events_count',
    'MsgTailgatingDetection_all_events_count',
    'MsgEyesOffRoad_all_events_count',
    'MsgHardbrake_all_events_count',
    'MsgNearCollision_all_events_count',
    'MsgCollisionTrackDetection_all_events_count',
    'MsgRecurringEOR_all_events_count',
    'MsgRecurringTG_all_events_count',
    'MsgSleep_all_events_count',
    'MsgSpeedingDetection_all_events_count',
];
const DRIVEN_DURATION_HOUR = 'total_driven_duration';
const DRIVEN_DURATION_WELL_HOUR = 'driven_duration_well';
const ACCIDENT_COUNT = 'accident_ids';

/** Maps metadata field names to score component keys used in translations (eor, tg, …). */
const METADATA_KEY_TO_COMPONENT_KEY: Record<string, string> = {
    eor_fine: 'eor',
    tg_fine: 'tg',
    hb_fine: 'hb',
    nc_fine: 'nc',
    claim_fine: 'claim',
    compliance_fine: 'compliance',
    tg_all_events_count: 'tg',
    eor_all_events_count: 'eor',
    hb_all_events_count: 'hb',
    nc_all_events_count: 'nc',
    MsgEyesOffRoad_fine: 'eor',
    MsgTailgatingDetection_fine: 'tg',
    MsgHardbrake_fine: 'hb',
    MsgNearCollision_fine: 'nc',
    MsgCollisionTrackDetection_fine: 'collision',
    MsgRecurringEOR_fine: 'recurring_eor',
    MsgRecurringTG_fine: 'recurring_tg',
    MsgSleep_fine: 'sleep',
    MsgSpeedingDetection_fine: 'speed',
    MsgEyesOffRoad_all_events_count: 'eor',
    MsgHardbrake_all_events_count: 'hb',
    MsgNearCollision_all_events_count: 'nc',
    MsgCollisionTrackDetection_all_events_count: 'collision',
    MsgRecurringEOR_all_events_count: 'recurring_eor',
    MsgRecurringTG_all_events_count: 'recurring_tg',
    MsgSleep_all_events_count: 'sleep',
    MsgSpeedingDetection_all_events_count: 'speed',
    MsgTailgatingDetection_all_events_count: 'tg',
};

const extractKeys = (metadata: string, key_list: string[]): Record<string, number> => {
    try {
        const metadataJson = JSON.parse(metadata);
        const result: Record<string, number> = {};
        for (const key of key_list) {
            const value = metadataJson[key];
            if (!value) {
                continue;
            }
            const componentKey = METADATA_KEY_TO_COMPONENT_KEY[key];
            if (componentKey) {
                result[componentKey] = (result[componentKey] ?? 0) + (value as number);
            }
        }
        return result;
    } catch (e) {
        return {};
    }
};

const extractSingleKey = (metadata: string, key: string): number => {
    try {
        const metadataJson = JSON.parse(metadata);
        return metadataJson[key] || 0;
    } catch (e) {
        return 0;
    }
};

export const getDrivenDurationHour = (metadata: string): number => {
    return extractSingleKey(metadata, DRIVEN_DURATION_HOUR);
};

export const getDrivenDurationWellHour = (metadata: string): number => {
    return extractSingleKey(metadata, DRIVEN_DURATION_WELL_HOUR);
};

export const getAccidentCount = (metadata: string): number => {
    try {
        const data = JSON.parse(metadata);
        const ids = data[ACCIDENT_COUNT];
        return Array.isArray(ids) ? ids.length : 0;
    } catch {
        return 0; // return 0 if parsing fails or field missing
    }
};

export const getFines = (metadata: string) => extractKeys(metadata, FINES);
export const getEventCounts = (metadata: string) => extractKeys(metadata, EVENT_COUNTS);
